import ZHighlightedBlock from './ZHighlightedBlock.vue'
export default ZHighlightedBlock
